import moment from 'moment';

// External data
import * as gConst from 'services/constants';
import { getAppointmentViewState } from 'src/services/functions';

const startCovidDate = moment.utc('16 March 2020').startOf('day'); // 16.03.20
const endCovidDate = moment.utc('19 April 2020').endOf('day'); // 19.04.20

//──── Filters ───────────────────────────────────────────────────────────────────────────
const findStatusMatch = (statusList, matchStatus) => {
  if (Array.isArray(statusList) && matchStatus) {
    return statusList.find(statuses => statuses.indexOf(matchStatus) > -1);
  }
  return false;
};

export const filterAppointsByStatusesWithCovid = (appointsList, statuses) => {
  let filterList = [];
  if (Array.isArray(appointsList) && appointsList && Array.isArray(statuses)) {
    filterList = appointsList.filter(appoint => {
      const appointStatus = getAppointmentViewState(appoint);
      if (appointStatus === gConst.STATUS_CANCELLED) {
        if (appoint.cancellationDateTime) {
          const cancelDate = moment.utc(appoint.cancellationDateTime);
          const isCovid = cancelDate.isBetween(startCovidDate, endCovidDate);
          if (isCovid && findStatusMatch(statuses, gConst.STATUS_CANCELLED_FROM_COVID)) {
            return true;
          }
          if (!isCovid && findStatusMatch(statuses, gConst.STATUS_CANCELLED)) {
            return true;
          }
          return false;
        }
        return findStatusMatch(statuses, appointStatus);
      } else {
        return findStatusMatch(statuses, appointStatus);
      }
    });
  }
  return filterList;
};